
import { defineComponent, PropType } from "vue";

import MultiRangeSlider from "/node_modules/multi-range-slider-vue/MultiRangeSlider.vue";
import { LocaleStrings, MultiRangeValues } from "@/types/paramModels";
import { useDebounceFn } from "@vueuse/core";

export default defineComponent({
  name: "EasyMultiRangeSlider",
  components: {
    MultiRangeSlider,
  },
  emits: ["sliderUpdate", "minValueUpdate", "maxValueUpdate"],
  props: {
    label: {
      type: String,
      required: true,
    },
    minValue: {
      type: Number,
      required: true,
    },
    maxValue: {
      type: Number,
      required: true,
    },
    minValueAvailable: {
      type: Number,
      required: true,
    },
    maxValueAvailable: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    inputPostfix: {
      type: String,
      required: false,
    },
    minId: {
      type: String,
      required: true,
    },
    maxId: {
      type: String,
      required: true,
    },
    minLabel: {
      type: String,
      required: true,
    },
    maxLabel: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      required: false,
    },
    formatToCurrency: {
      type: Boolean,
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props, { emit }) {
    const minFocus = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.value === "0") {
        input.value = "";
      }
    };

    const minEmptyCheck = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.value === "") {
        input.value = _props.minValueAvailable.toString();
      }
    };

    const maxFocus = (event: Event) => {
      // const input = event.target as HTMLInputElement;
      // if (input.value === _props.maxValueAvailable.toString()) {
      //     input.setSelectionRange(0, input.value.length)
      // }
    };

    const maxEmptyCheck = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.value === "") {
        input.value = _props.maxValueAvailable.toString();
      }
    };

    const formatValue = (event: Event) => {
      const input = event.target as HTMLInputElement;
      let inputValue = parseInt(input.value.replace(/[.]/g, ""));
      input.value = inputValue.toLocaleString(_props.localeStrings.longName);
      input.value = input.value.replace(/[^0-9.]/g, "");
      if (inputValue !== null && !isNaN(inputValue)) {
        const changeEvent = new Event("change");
        input.dispatchEvent(changeEvent);
      }
    };

    const minValueUpdate = useDebounceFn((event: Event) => {
      const input = event.target as HTMLInputElement;
      let inputValue = parseInt(input.value.replace(/[.]/g, ""));
      if (!inputValue || inputValue < _props.minValueAvailable) {
        inputValue = _props.minValueAvailable;
        input.value = inputValue.toString();
      } else if (inputValue > _props.maxValueAvailable) {
        inputValue = _props.maxValueAvailable;
        input.value = inputValue.toString();
      } else if (inputValue > _props.maxValue) {
        inputValue = _props.maxValue;
        input.value = inputValue.toString();
      }
      emit("minValueUpdate", inputValue);
    }, 500);

    const maxValueUpdate = useDebounceFn((event: Event) => {
      const input = event.target as HTMLInputElement;
      let inputValue = parseInt(input.value.replace(/[.]/g, ""));
      if (!inputValue || inputValue > _props.maxValueAvailable) {
        inputValue = _props.maxValueAvailable;
        // input.value = inputValue.toString();
      } else if (inputValue < _props.minValueAvailable) {
        inputValue = _props.minValueAvailable;
        // input.value = inputValue.toString();
      } else if (inputValue < _props.minValue) {
        inputValue = _props.minValue;
        // input.value = inputValue.toString();
      }
      emit("maxValueUpdate", inputValue);
    }, 500);

    const sliderUpdate = useDebounceFn((values: MultiRangeValues) => {
      emit("sliderUpdate", values);
    }, 500);

    return {
      minFocus,
      minEmptyCheck,
      maxFocus,
      maxEmptyCheck,
      minValueUpdate,
      maxValueUpdate,
      sliderUpdate,
      formatValue,
    };
  },
});
